import React, { useState } from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ContactMenu from '../../ContactMenu';
import Popup from '../../Modal/PopUp';
import Snackbar from '../../Snackbar';
import { unsetSaved } from '../../../store/actions/UserAction';

const mintMarker = '/img/icons/bandera-mint.svg';
const mintCircle = '/img/icons/mono-verde.svg';
const grayCircle = '/img/icons/mono-gray.svg';
const menu = '/img/icons/menu-options.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginBottom: 16,
  },
  name: {
    width: '100%',
    fontSize: 16,
    fontWeight: 'bold',
    margin: '16px 0 0',
    maxWidth: 476,
    color: '#10587f',
    lineHeight: 'normal',
  },
  textMsg: {
    padding: '0 16px',
    marginTop: 9,
  },
}));

const ExpansionPanel = withStyles({
  root: {
    boxShadow: 'none',
    color: '#484848',
    border: '1px solid #e7e7e7',
    marginBottom: 10,
    borderRadius: 4,
    width: 632,
    '@media screen and (max-width: 940px)': {
      width: '100%',
    },
  },
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    padding: '0 16px',
    minHeight: 56,
    position: 'relative',
    '&:hover': {
      cursor: 'auto',
    },
    '@media screen and (max-width: 1017px)': {
      minHeight: 'unset',
    },
    
  },
  content: {
    margin: '0 0 15px',
    width: '100%',
    paddingRight: 24,
  },
})(MuiExpansionPanelSummary);

function Contact(props) {
  const classes = useStyles();
  const { user, unsetSaved, messagesLaw ,userUid} = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [feedbackMessage, setOpenFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'success',
  },)

  const handleClose = () => {
    setOpen(false);
  };

  const confirmDelete = () => {
    setOpen(false);
    unsetSaved(user.uid, user.save, messagesLaw, userUid).then(res => {
      setOpenFeedbackMessage({
        open: true,
        message: 'El contacto se ha eliminado con éxito',
        variant: 'success',
      });
    });
  };

  const handleOpenMenu = (event) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleDelete = () => {
    handleCloseMenu()
    setOpen(true);
  };

  const handleCloseFeedbackMessage = () => {
    setOpenFeedbackMessage({
      open: false,
      message: '',
      variant: 'success',
    })
  };

  return (
    <div className={classes.root}>
      <ExpansionPanel expanded={false}>
        <ExpansionPanelSummary
          aria-controls="panel2a-content"
          id="panel2a-header"
          className="message-summary"
        >
          {user.clientUid ? (
            <img
              src={mintCircle}
              style={{
                width: 16,
                height: 16,
                margin: '18px 8px 0 0',
              }}
              alt="usuario registrado"
            />
          ) : (
            <img
              src={grayCircle}
              style={{
                width: 16,
                height: 16,
                margin: '18px 8px 0 0',
              }}
              alt="usuario no registrado"
            />
          )}
          <div className="savedContact">
            <img src={mintMarker} alt="contacto guardado" />
          </div>
          <div style={{ width: '100%' }}>
            <Typography className={classes.name}>{user.name}</Typography>
            {/*             <small className="message-date">{user.localidad}</small>
             */}{' '}
            <div
              className="contactInfo-details"
              style={{ marginLeft: 0, marginTop: 9 }}
            >
              <div className="contactInfo-phone">
                <p className="contactInfo-text contactInfo-bold city">
                  Correo:<span className="contactInfo-text"> {user.email}</span>
                </p>
                <div className="line-separation"></div>
                <p className="contactInfo-text contactInfo-bold">
                  Teléfono:
                  <span className="contactInfo-text"> {user.phone}</span>
                </p>
              </div>
            </div>
          </div>

          <button className="menu-options-button" onClick={handleOpenMenu}>
            <img src={menu} alt="Opciones" />
          </button>
        </ExpansionPanelSummary>
      </ExpansionPanel>

      <ContactMenu
        anchorEl={anchorEl}
        handleClose={handleCloseMenu}
        handleDelete={handleDelete}
      />

      <Popup
        open={open}
        handleClose={handleClose}
        title="¿Seguro que deseas eliminar este contacto?"
        subtitle="Al eliminar un contacto pierdes interacción con un cliente potencial, para regresar oprime el botón CANCELAR."
        primaryButton={true}
        primaryButtonVariant="primarySolidOutlined"
        primaryButtonText="Sí, Eliminar"
        primaryFunction={confirmDelete}
        secondaryButton={true}
        secondaryButtonVariant="primary"
      />

      <Snackbar
        open={feedbackMessage.open}
        variant={feedbackMessage.variant}
        message={feedbackMessage.message}
        handleClose={handleCloseFeedbackMessage}
        vertical="top"
        horizontal="right"
        snackbarTop={isMobile ? '70px' : '80px'}
      />
    </div>
  );
}

const mapDispatchToProps = dispatch => ({
  unsetSaved: (uid, saved, arrayContacts, userUid) => dispatch(unsetSaved(uid, saved, arrayContacts, userUid)),
})

export default connect(null, mapDispatchToProps)(Contact);
